import { z } from "zod";

const envSchema = z.object({
  VITE_API_URL: z.string(),
  VITE_APP_ENV: z.enum(["development", "staging", "uat", "production"]).default("staging"),
  VITE_COLLAB_ENV: z.enum(["development", "staging", "uat", "production"]).default("staging"),
  VITE_LS_KEY_PREFIX: z.string(),
  VITE_AUTH_PORTAL_URL: z.string(),
  VITE_COLLAB_SERVER_URL: z.string(),
  VITE_ROLLBAR_TOKEN: z.string().optional(),
  VITE_OBSERVER_FRONT_URL: z.string().optional(),
  // Build-time switch for the Grid picture picker. Off when unset, so a build
  // that forgets it keeps the library picker.
  VITE_GRID_PICKER: z
    .enum(["true", "false"])
    .default("false")
    .transform((v) => v === "true"),
});

export const env = envSchema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_COLLAB_ENV: import.meta.env.VITE_COLLAB_ENV,
  VITE_LS_KEY_PREFIX: import.meta.env.VITE_LS_KEY_PREFIX,
  VITE_AUTH_PORTAL_URL: import.meta.env.VITE_AUTH_PORTAL_URL,
  VITE_COLLAB_SERVER_URL: import.meta.env.VITE_COLLAB_SERVER_URL,
  VITE_ROLLBAR_TOKEN: import.meta.env.VITE_ROLLBAR_TOKEN,
  VITE_OBSERVER_FRONT_URL: import.meta.env.VITE_OBSERVER_FRONT_URL,
  VITE_GRID_PICKER: import.meta.env.VITE_GRID_PICKER,
});
